export const BASE_API_URL = "https://api.cinema.idc.md";

// номер версии с датой
export const version = "3.7.7 от 21.10.2026";
